"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationsSidebar_1 = __importDefault(require("./components/NotificationsSidebar"));
var StudentNotificationsPreferences_1 = __importDefault(require("./components/StudentNotificationsPreferences"));
var bootstrap_1 = require("./bootstrap");
var notificationsStore_1 = require("./storage/notificationsStore");
var preferencesStore_1 = require("./storage/preferencesStore");
var mountIsland_1 = require("../mountIsland");
var preferencesContainer = document.getElementById('notifications-preferences-container');
var notificationsSidebar = document.getElementById('notifications-vertical-sidebar');
/**
 * One-time hydration from server-injected JSON.
 * This avoids any extra network calls on first render.
 */
(function () {
    var prefsBoot = (0, bootstrap_1.bootPreferencesFromDOM)();
    if (prefsBoot) {
        (0, preferencesStore_1.initPreferences)(prefsBoot);
        (0, notificationsStore_1.initUnreadCount)({ userId: prefsBoot.userId, unreadCount: prefsBoot.unreadCount });
        return;
    }
    // Fallback: if only unreadCount is present
    var unread = (0, bootstrap_1.bootUnreadOnlyFromDOM)();
    if (unread.userId) {
        (0, notificationsStore_1.initUnreadCount)(unread);
    }
})();
var PreferencesRoot = function () {
    var _a;
    var prefs = (0, preferencesStore_1.usePreferencesStore)();
    // Your StudentNotificationPreferences currently needs userId and uses its own hook;
    // pass userId from the boot payload.
    return react_1.default.createElement(StudentNotificationsPreferences_1.default, { userId: (_a = prefs.userId) !== null && _a !== void 0 ? _a : 0 });
};
var SidebarRoot = function () {
    var unreadCount = (0, notificationsStore_1.useUnreadCount)();
    return react_1.default.createElement(NotificationsSidebar_1.default, { unreadCount: unreadCount });
};
if (preferencesContainer) {
    (0, mountIsland_1.mountIsland)(preferencesContainer, react_1.default.createElement(PreferencesRoot, null));
}
if (notificationsSidebar) {
    (0, mountIsland_1.mountIsland)(notificationsSidebar, react_1.default.createElement(SidebarRoot, null));
}
